import { createBrowserRouter, Outlet } from 'react-router-dom'
import { ProtectedRoute, AppLayout } from '@/components'
import {
  LoginPage,
  DashboardPage,
  BuildingsPage,
  BuildingDetailPage,
  RoomsPage,
  RoomDetailPage,
  AssetsPage,
  AssetDetailPage,
  ReportsPage,
  ReportCreatePage,
  ReportEditPage,
  ReportDetailPage,
  UsersPage,
  ProfilePage,
  BrandingSettingsPage,
  OrganizationSettingsPage,
  OrganizationsPage,
  OrgDetailPage,
  ExportsPage,
  ImportsPage,
  CompliancePage,
  PublicRoomDisplayPage,
} from '@/pages'

function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold">404</h1>
        <p className="text-muted-foreground mt-2">Page not found.</p>
      </div>
    </div>
  )
}

/**
 * Protected layout wrapper that includes AppLayout.
 */
function ProtectedLayout() {
  return (
    <ProtectedRoute>
      <AppLayout>
        <Outlet />
      </AppLayout>
    </ProtectedRoute>
  )
}

/**
 * React Router configuration.
 */
export const router = createBrowserRouter([
  // Public routes (no auth required)
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/room/:roomId',
    element: <PublicRoomDisplayPage />,
  },

  // Protected routes with AppLayout
  {
    element: <ProtectedLayout />,
    children: [
      {
        path: '/',
        element: <DashboardPage />,
      },
      {
        path: '/buildings',
        element: <BuildingsPage />,
      },
      {
        path: '/buildings/:buildingId',
        element: <BuildingDetailPage />,
      },
      {
        path: '/rooms',
        element: <RoomsPage />,
      },
      {
        path: '/rooms/:roomId',
        element: <RoomDetailPage />,
      },
      {
        path: '/reports',
        element: <ReportsPage />,
      },
      {
        path: '/reports/new',
        element: <ReportCreatePage />,
      },
      {
        path: '/reports/:reportId',
        element: <ReportDetailPage />,
      },
      {
        path: '/reports/:reportId/edit',
        element: <ReportEditPage />,
      },
      {
        path: '/assets',
        element: <AssetsPage />,
      },
      {
        path: '/assets/:assetId',
        element: <AssetDetailPage />,
      },
      {
        path: '/users',
        element: <UsersPage />,
      },
      {
        path: '/settings',
        element: <ProfilePage />,
      },
      {
        path: '/settings/branding',
        element: <BrandingSettingsPage />,
      },
      {
        path: '/settings/organization',
        element: <OrganizationSettingsPage />,
      },
      {
        path: '/organizations',
        element: <OrganizationsPage />,
      },
      {
        path: '/organizations/:orgId',
        element: <OrgDetailPage />,
      },
      {
        path: '/exports',
        element: <ExportsPage />,
      },
      {
        path: '/imports',
        element: <ImportsPage />,
      },
      {
        path: '/compliance',
        element: <CompliancePage />,
      },
    ],
  },

  // Catch-all for 404
  {
    path: '*',
    element: <NotFoundPage />,
  },
])
